<template>
    <div
        :data-project-id="project.idProgetto"
        class="progetto"
    >
        <div class="bg-white border rounded">
            <div class="d-flex flex-wrap p-1">
                <div class="img pr-2 border-right d-flex flex-column justify-content-center">
                    <div class="img-container w-100">
                        <div class="img-wrapper">
                            <img :src="getProjectUrl()" />
                        </div>
                    </div>
                </div>
                <div class="info pl-2 h-100">
                    <div v-if="isProjectShared()">
                        <p class="project-name mb-0">Progetto: <span class="value">{{project.titolo}}</span></p>
                        <p class="project-long-type mb-0">{{project.descrizione}}</p>
                        <p class="project-price mb-0 mt-2">Prezzo di Vendita: <span class="value">{{parseFloat(project.prezzo) | toCurrency}}</span></p>
                    </div>
                    <div v-else>
                        <p class="project-type mb-1 text-uppercase text-blurikorda">{{project.titolo}}</p>
                        <p class="project-name mb-0">Progetto: <span class="value">{{project.descrizione}}</span></p>
                        <div class="project-dates mt-1 d-flex flex-wrap">
                            <p class="project-creation-date d-inline-block mb-0 mr-2">Creato il: <span class="value">{{project.dataCreazione | formatDateSlash}}</span></p>
                            <p class="project-expiration-date d-inline-block mb-0">Scade il: <span class="value">{{project.dataCancellazione | formatDateSlash}}</span></p>
                        </div>
                    </div>

                    <ul class="imgs mt-3 d-flex flex-wrap">
                        <li
                            v-for="imageId in project.immagini"
                            :key="imageId"
                        >
                            <img :src="getProjectThumbUrl(imageId)" />
                        </li>
                        <li v-if="project.immagini && project.immagini.length == 0"></li>
                    </ul>
                </div>
            </div>
            <div
                v-if="isProjectShared()"
                class="d-flex justify-content-between flex-wrap border-top p-1"
            >
                <button
                    type="button"
                    class="pulsante-modifica-progetto btn btn-rikorda2-alt mr-1"
                    @click="onAddProjectShare"
                >
                    {{ $t("Modifica") }}
                </button>
                <button
                    type="button"
                    class="pulsante-rimuovi-progetto btn btn-rikorda1"
                    @click="onRemoveProjectShare"
                >
                    {{ $t("Rimuovi dall'evento") }}
                </button>
            </div>
            <div
                v-else
                class="d-flex flex-wrap border-top p-1"
                :class="{'justify-content-center': !project.eventId, 'justify-content-left': project.eventId}"
            >
                <button
                    v-if="!project.eventId"
                    type="button"
                    class="pulsante-includi-progetto btn btn-rikorda1"
                    @click="onAddProjectShare"
                >
                    {{ $t("Aggiungi all'evento") }}
                </button>
                <div v-else>
                    <button
                        type="button"
                        class="pulsante-progetto-condiviso btn btn-rikorda1"
                        @click="onAddProjectShare"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'info']"
                            class="float-left"
                        />
                    </button>
                    <span class="ml-1">
                        {{ $t("Progetto già condiviso con l'evento") }}
                        &nbsp;
                        <span class="text-blurikorda font-titoli-rikorda">{{ project.eventTitle }}</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GalleryProject",
    props: ["eventId", "project", "mode", "gallery"],

    data() {
        return {};
    },

    mounted() {},

    methods: {
        isProjectShared() {
            return this.mode === "edit";
        },

        getProjectUrl() {
            let url = this.$imagesService.getProjectUrl(
                this.eventId,
                this.project.idProgetto
            );
            if (url.length > 0) {
                url += "&refresh=" + new Date().getTime();
            }
            return url;
        },

        getProjectThumbUrl(imageId) {
            return this.$imagesService.getProjectThumbUrl(imageId);
        },

        onAddProjectShare() {
            this.$emit("share");
        },

        onRemoveProjectShare() {
            this.$emit("unshare");
        }
    }
};
</script>

<style>
</style>
